import React, { useState } from "react";
import arrowDown from "./../../assets/img/arrow_down.png";
import arrowUp from "./../../assets/img/arrow_up.png";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";
import Icon from "@material-ui/core/Icon";
import moment from "moment";

// @material-ui/icons
import Place from "@material-ui/icons/Place";
import { makeStyles } from "@material-ui/core/styles";
import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

import { useParams } from "react-router-dom";

const useStyles = makeStyles(menuStyle);

function checkColor(color) {
  var c = color.substring(1); // strip #
  var rgb = parseInt(c, 16); // convert rrggbb to decimal
  var r = (rgb >> 16) & 0xff; // extract red
  var g = (rgb >> 8) & 0xff; // extract green
  var b = (rgb >> 0) & 0xff; // extract blue
  var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
  if (luma < 100) {
    return "white";
  } else {
    return "#303030";
  }
}

const EventCategory = (props) => {
  const [open, setOpen] = useState(false);

  const { category, museum, updateEventSelected, windowSize } = props;

  const { home } = useParams();

  const classes = useStyles();

  const { t } = useTranslation();

  const styles = {
    container: {
      display: "flex",
      width: windowSize.innerWidth > 800 ? "100%" : "90%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: museum?.colore || "#303030",
      marginBottom: "10px",
      cursor: "pointer",
      borderRadius: windowSize.innerWidth > 800 ? "" : "10px",
    },
    title: {
      color: museum?.colore ? checkColor(museum?.colore) : "#303030",
      marginLeft: 30,
      paddingTop: "10px",
      textAlign: "left",
    },
    content: {
      width: windowSize.innerWidth > 800 ? "100%" : "90%",
    },
    scroller: {
      overflowY: "scroll",
    },
  };

  return (
    <>
      <div style={styles.container} onClick={() => setOpen(!open)}>
        <p style={styles.title}>{category.name?.toUpperCase()}</p>
        <img
          alt="Arrow icon"
          src={open ? arrowUp : arrowDown}
          style={{ width: "15px", objectFit: "contain", margin: "20px" }}
        />
      </div>
      {open && (
        <div style={styles.content}>
          <div>
            <div style={{ height: "100%", width: "100%" }} id="scroll">
              {category.events
                .filter((e) => e.biglietti_eventis.length > 0)
                .map((el, index) => {
                  let noAvailablePlaces = true;
                  el.eventi_child.forEach((child) => {
                    noAvailablePlaces =
                      noAvailablePlaces && child.posti_disponibili === 0;
                  });
                  return (
                    <div
                      key={`list-event-${index.toString()}`}
                      style={{ scrollBehavior: "smooth" }}
                    >
                      {(el.immagine_evento && el.immagine_evento.url) ||
                      (museum.cover && museum.cover.url) ? (
                        <div
                          style={{ outline: "1px gray solid" }}
                          className="row_view_museum_list_container row_event_container"
                        >
                          <Link
                            onClick={() => {
                              updateEventSelected(el);
                            }}
                            to={`/${museum?.identificativo}/event/${el.id}/${home}`}
                            title={el.nome_evento}
                          >
                            {noAvailablePlaces ? (
                              <div
                                className="row_view_museum_list_image"
                                style={{
                                  filter: `blur(8px)`,
                                  backgroundImage: `url('${
                                    el.immagine_evento && el.immagine_evento.url
                                      ? el.immagine_evento.url
                                      : museum.cover.url
                                  }')`,
                                }}
                              />
                            ) : (
                              <div
                                className="row_view_museum_list_image"
                                style={{
                                  backgroundImage: `url('${
                                    el.immagine_evento && el.immagine_evento.url
                                      ? el.immagine_evento.url
                                      : museum.cover.url
                                  }')`,
                                }}
                              />
                            )}
                          </Link>
                          <div
                            style={{ outile: "1px solid black" }}
                            className="row_view_museum_list_text_side"
                          >
                            <div className="no_available_places">
                              {noAvailablePlaces && (
                                <span>{t("soldOutEvent")}</span>
                              )}
                            </div>
                            <div className="row_view_museum_title_container">
                              {el.ora_inizio ? (
                                <div className="row_view_museum_day">
                                  {el.ora_fine &&
                                  moment(el.ora_inizio).format("l") ===
                                    moment(el.ora_fine).format("l") ? (
                                    <div>
                                      <div>
                                        <span>
                                          {moment(el.ora_inizio).format(
                                            "DD/MM/YYYY"
                                          )}
                                        </span>
                                      </div>
                                      <div>
                                        dalle{" "}
                                        {moment(el.ora_inizio).format("HH:mm")}:{" "}
                                        alle{" "}
                                        {moment(el.ora_fine).format("HH:mm")}
                                      </div>
                                    </div>
                                  ) : (
                                    <span>
                                      {el.ora_fine ? (
                                        <div>
                                          <div>
                                            <span>
                                              Dal{" "}
                                              {moment(el.ora_inizio).format(
                                                "DD/MM/YYYY"
                                              )}{" "}
                                              al{" "}
                                              {moment(el.ora_fine).format(
                                                "DD/MM/YYYY"
                                              )}
                                            </span>
                                          </div>
                                          <div>
                                            dalle{" "}
                                            {moment(el.ora_inizio).format(
                                              "HH:mm"
                                            )}{" "}
                                            alle{" "}
                                            {moment(el.ora_fine).format(
                                              "HH:mm"
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <div>
                                          <div>
                                            <span>
                                              {moment(el.ora_inizio).format(
                                                "DD/MM/YYYY"
                                              )}
                                            </span>
                                          </div>
                                          <div>
                                            dalle{" "}
                                            {moment(el.ora_inizio).format(
                                              "HH:mm"
                                            )}{" "}
                                            alle{" "}
                                            {moment(el.ora_fine).format(
                                              "HH:mm"
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </span>
                                  )}
                                </div>
                              ) : null}
                              <div className="museum_list_address">
                                <Icon
                                  className={classes.iconButton}
                                  key="place"
                                  aria-label="Place"
                                  color="inherit"
                                  style={{ width: 20, marginRight: 10 }}
                                >
                                  <Place className={classes.close} />
                                </Icon>{" "}
                                {el.luogo_evento ? (
                                  el.luogo_evento
                                ) : (
                                  <span>
                                    {museum.indirizzo_museo || ""},{" "}
                                    {museum.citta_museo || ""}{" "}
                                    {museum.CAP_museo || ""}
                                  </span>
                                )}
                              </div>
                              <Link
                                onClick={() => {
                                  updateEventSelected(el);
                                }}
                                to={`/${museum.identificativo}/event/${el.id}/${home}`}
                                title={el.nome_evento}
                                className="museum_list_title"
                              >
                                {el.nome_evento}
                              </Link>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EventCategory;
